import { render, staticRenderFns } from "./AgentWorkload.vue?vue&type=template&id=27451e30&scoped=true&"
import script from "./AgentWorkload.vue?vue&type=script&lang=js&"
export * from "./AgentWorkload.vue?vue&type=script&lang=js&"
import style0 from "./AgentWorkload.vue?vue&type=style&index=0&id=27451e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27451e30",
  null
  
)

export default component.exports